import { schema } from "normalizr";
import { GenericFilterRecord } from "records/filter";

const GenericFilterSchema = new schema.Entity(
    "genericFilters",
    {},
    {
        idAttribute: "__name", // set id on server maybe?
    }
);

(GenericFilterSchema as any).record = GenericFilterRecord;

export default GenericFilterSchema;
